import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { FailedLogo } from "../../asset";
import PrimaryButton from "../button/PrimaryButton";

const ModalFailedDelete = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        visible={props.show}
        closable={false}
        centered={true}
        width={`${props.width ? props.width : 414}px`}
        footer={null}
      >
        <div className="flex flex-col justify-center items-center gap-[9px] pt-6">
          <img src={FailedLogo} alt="fail" />
          <div className="flex flex-col justify-center items-center">
            <h2 className="font-roboto text-3xl font-bold mb-[16px]">
              {props.title}
            </h2>
            <p className="font-roboto text-[#666666] text-center mb-[16px] font-normal text-lg">
              {props.description}
            </p>
          </div>
        </div>
        <div className="content-center ml-4 mr-4">
        <PrimaryButton
          text={t("USER_DETAIL:Ok")}
          action={() => props.action()}
          styles="w-full rounded-md"
        />
        </div>
      </Modal>
    </>
  );
};
export default ModalFailedDelete;
